import * as d3 from 'd3'

export default {
  methods: {

    draw_Donuts(selection, data) {

      let donut = this.donuts

      let donutChart = selection
      .append('g')
      .attr('transform', `translate(${donut.x}, ${donut.y})`)

      donutChart
      .append('line')
      .attr('x1', donut.radius).attr('x2', donut.radius + (donut.radius*2+donut.gap) * (donut.cols.length-1))
      .attr('y1', donut.radius).attr('y2', donut.radius)
      .attr('stroke', '#bcbcbc').attr('stroke-width', 2).attr('opacity', .3)

      let cx = donut.radius
      donut.cols.forEach((col,i)=> {
        
        let values = donutChart
        .append('g')
        .attr('transform', `translate(${cx}, ${0})`)

        values
        .append('circle')
        .attr('cx', 0).attr('cy', donut.radius).attr('r', donut.radius - (donut.thick/2))
        .attr('fill', '#fff').attr('stroke', '#E0E0DF')
        .attr('stroke-width', 1).attr('opacity', 1)

        values
        .append('text')
        .attr('x', 0).attr('y', donut.radius +4)
        .attr('fill', '#333').attr('font-size', 10).attr('text-anchor', 'middle')
        .text(data[col.code+'_PRO'] + '%')
        
        console.log(`${col.code}_${col.sch1}`)
        // Schedule
        let y_ = donut.radius*2 + 13

        if(data[`${col.code}_${col.sch1}`]) {
          values // Sch1
          .append('text')
          .attr('x', 0).attr('y', y_)
          .attr('fill', col.tColor1).attr('font-size', 10).attr('text-anchor', 'middle')
          .text(data[`${col.code}_${col.sch1}`])

          y_ += 13
        }

        if(data[`${col.code}_${col.sch2}`]) {
          values // Sch2
          .append('text')
          .attr('x', 0).attr('y', y_)
          .attr('fill', col.tColor2).attr('font-size', 10).attr('text-anchor', 'middle')
          .text(data[`${col.code}_${col.sch2}`])
          
          y_ += 13
        }

        values // Item
        .append('text')
        .attr('x', 0).attr('y', -5)
        .attr('fill', '#000').attr('font-size', 11).attr('text-anchor', 'middle')
        .text(col.name)

        this.draw_Circle(donutChart, cx, col, data[col.code+'_PRO']) // -----> Below
        cx = cx + (donut.gap + (donut.radius*2))
      })

    },


    draw_Circle(selection, cx, col, prog) {
    
          let donut = this.donuts
          let endAn = ''
    
          let arc = d3.arc()
          .outerRadius(donut.radius)
          .innerRadius(donut.radius - donut.thick)
          .startAngle(Math.PI / 180)
          .endAngle(() => endAn || 360 * Math.PI / 180)
          .cornerRadius(donut.thick)
    
          let chart = selection
          .append('g')
          .attr('transform', `translate(${cx}, ${donut.radius})`)
    
          if(prog==0) return
          chart
          .append('path')
          .attr('d', arc)
          .attr('fill', col.color)
          .transition().duration(500)
          .attrTween('d', ()=> {
            let endAngle_ = ( ((360 * (prog/100)) ) * Math.PI / 180)
            let interpolate = d3.interpolate(0 * Math.PI / 180, endAngle_)
            return function(t) {
              endAn = interpolate(t)
              return arc()
            }
          })
        },

        
  }
}